import * as React from 'react';
import {
    CardMedia,
    IconButton,
    Tooltip,
    Box,
} from '@material-ui/core';
import { CostumeEntry } from '../../../sprite';
import DeleteIcon from '@material-ui/icons/Delete';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';

import HoveringCard from '../HoveringCard/HoveringCard';
import { useTranslation } from 'react-i18next';


/***
 * Props for the {@link CostumeDisplay} component.
 */
interface ContentDisplayProps {
    readonly index: number;
    readonly isActive: boolean;
    /** The costume to container */
    readonly costume: CostumeEntry;
    /** Called when the delete icon is clicked */
    readonly deleteCostume?: (costume: CostumeEntry) => void;
    /** Called when the container was clicked */
    readonly onCostumeClicked?: (costume: CostumeEntry) => void;
    /** Called when the name was changed */
    readonly onCostumeNameChanged?: (costume: CostumeEntry) => void;
    /** Optional Readonly-flag which forbids editing the title and setting the deleteable state */
    readonly readonly?: boolean;
    /** Optional method called when right-clicking the costume */
    readonly setIsSystemState?: (costume: CostumeEntry) => void;
    /** Number of Costumes*/
    readonly onlyCostume?: boolean;
    readonly name?: string;
}

// const MAX_NAME_LENGTH = 20;

/***
 * Container for displaying a costume.
 * It provides an interface for deletion and changing the name.
 * Callbacks can be injected via the component props.
 */
const ContentDisplay: React.FC<ContentDisplayProps> = (props) => {
    // const [editName, setEditName] = React.useState(false);
    const [isSystemCostumeState, setIsSystemCostumeState] = React.useState(props.costume.isSystemCostume);

    // const handleNameInputTrigger = (e?: React.MouseEvent | React.FocusEvent) => {
    //     if (e) {
    //         e.stopPropagation();
    //     }
    //     if (editName) {
    //         if (props.onCostumeNameChanged) {
    //             props.onCostumeNameChanged(props.costume);
    //         }
    //     }
    //     setEditName(!editName);
    // };

    // const catchEnterKey = (e: React.KeyboardEvent) => {
    //     if (editName && e.key === "Enter") {
    //         handleNameInputTrigger();
    //     }
    // };

    // const handleCostumeNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     if (e.target.value.length <= MAX_NAME_LENGTH) {
    //         props.costume.name = e.target.value;
    //     }
    // };

    const {t} = useTranslation();

    // let titleElement;
    // if (editName) {
    //     titleElement =
    //         (
    //             <FormControl>
    //                 <Input
    //                     multiline={true}
    //                     autoFocus={true}
    //                     onBlur={handleNameInputTrigger}
    //                     onKeyDown={catchEnterKey}
    //                     defaultValue={props.costume.name.replace(".png","")}
    //                     onChange={handleCostumeNameChange}
    //                     id="costumeName"
    //                     inputProps={{maxLength: MAX_NAME_LENGTH}}
    //                 />
    //             </FormControl>
    //         );
    // } else {
    //     if (props.costume.isSystemCostume) {
    //         titleElement =
    //             (
    //                 <Typography
    //                     style={{wordWrap: "break-word", maxHeight: "1.75rem"}}
    //                     variant="subtitle1"
    //                 >
    //                     {props.costume.name.replace(".png","")}
    //                 </Typography>
    //             );

    //     } else {
    //         titleElement =
    //             (
    //                 <Tooltip title={t('CostumeDisplay.ChangeNameTooltip') as string}>
    //                     <Typography
    //                         style={{wordWrap: "break-word", maxHeight: "1.75rem"}}
    //                         onClick={handleNameInputTrigger}
    //                         variant="subtitle1"
    //                     >
    //                         {props.costume.name.replace(".png","")}
    //                     </Typography>
    //                 </Tooltip>
    //             );
    //     }

    // }

    let costumeDeleteElement = [];
    /* Create delete and system buttons*/
    if (props.deleteCostume && !props.costume.isSystemCostume && !props.onlyCostume) {
        costumeDeleteElement.push(
            <Tooltip style={{marginBottom: "auto"}} title={t('CostumeDisplay.DeleteCostumeTooltip') as string}>
                <IconButton style={{ backgroundColor: '#CB253D', border: '2px solid rgb(111, 34, 18)', cursor: 'pointer', width: "42px", height: "42px" }} onClick={() => props.deleteCostume!(props.costume)} >
                    <DeleteIcon style={{ color: 'white', width: "20px", height: "20px" }} />
                </IconButton>
            </Tooltip>);
    }
    if (props.setIsSystemState) {
        costumeDeleteElement.push(
            <Tooltip style={{marginTop: "auto"}} title={t('CostumeDisplay.SetSystemCostumeTooltip') as string}>
                <IconButton size={'small'}
                            onClick={(event) => {
                                event.stopPropagation();
                                props.setIsSystemState!(props.costume);
                                setIsSystemCostumeState(props.costume.isSystemCostume);
                            }}>
                    {
                        isSystemCostumeState ? <LockIcon/> : <LockOpenIcon/>
                    }
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <HoveringCard
            style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#E6F0FF',
                borderRadius: '16px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                padding: '10px'
            }}
            onClick={() => props.onCostumeClicked?.(props.costume)}
        >
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                {props.name && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            padding: '5px 10px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            borderRadius: '8px 0 8px 0',
                        }}
                    >
                        {props.name}
                    </div>
                )}
                <CardMedia
                    style={{ objectFit: 'contain', aspectRatio: '4 / 3', width: '100%' }}
                    component="img"
                    src={props.costume.image.src}
                />
                <Box
                    display="flex"
                    flexDirection="column"
                    position="absolute"
                    top={0}
                    right={0}
                >
                    {costumeDeleteElement}
                </Box>
            </div>
        </HoveringCard>
    );
};

export default ContentDisplay;
